module.exports = __webpack_public_path__ + "media/honey-icons/hub-e51177e4.svg";